/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it

import "@fontsource/inter/400.css"
import "@fontsource/inter/600.css"
import "@fontsource/montserrat/500.css"

export const onClientEntry = () => {
  if (!sessionStorage.getItem("ak-forwarded")) {
    let val = "direct"
    if (document.referrer.length > 0) {
      val = document.referrer
    }
    sessionStorage.setItem("ak-forwarded", val)
  }
}
